module.exports = __webpack_public_path__ + "static/media/beeren.13ad67f1.png";